import type { AdapterMeta } from "@repo/adapter-core";

export const PROPERTY_COM_AU_ADAPTER_META: AdapterMeta = {
  slug: "property-com-au",
  name: "property.com.au",
  baseUrl: "https://www.property.com.au",
  description:
    "National property portal owned by REA Group with property profiles, sale history, and estimates.",
  supportedStates: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
  urlPattern: /property\.com\.au\/[a-z]{2,3}\/[\w-]+-\d{4}\/[\w-]+\/[\w-]+-pid-\d+$/i,
  sourceType: "portal",
};
